import React, { useState, useEffect } from "react";
import PermissionForm from "./PermissionForm";
import AddRoleForm from "./AddRoleForm";
import editIcon from "../assets/icons/EditIcon.svg";

const RoleSearch = ({ refreshTrigger }) => {  
  const [roles, setroles] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRole, setSelectedRole] = useState(null);
  const [showPermissionForm, setShowPermissionForm] = useState(false);
  const [showAddRoleForm, setShowAddRoleForm] = useState(false);

  const fetchroles = () => {
    fetch('/api/roles')
      .then(r => {
        if (!r.ok) throw new Error('Failed to fetch roles');
        return r.json();
      })
      .then(data => {
        setroles(data);
      })
      .catch(e => console.error('Error fetching Role:', e));
  };

  // Only one useEffect is needed
  useEffect(() => {
    fetchroles();
  }, [refreshTrigger]);

  const filteredroles = roles.filter((r) =>
    (r.role_name?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

  const handleAddRole = () => setShowAddRoleForm(true);
  const handleEditPermission = (role) => { setSelectedRole(role); setShowPermissionForm(true); };
  const handleSaveRole = () => { fetchroles(); setShowPermissionForm(false); };
  const handleRoleAdded = () => { fetchroles(); setShowAddRoleForm(false); };

  return (
    <div className="user-list-container">
      <h2>Role List</h2>

      <div>
        <label>Search:</label>
        <input
          type="text"
          placeholder="Search roles..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="button-container">
        <button className="add-Role-button" onClick={handleAddRole}>+ Add Role</button>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>Role Name</th>
              <th>Description</th>
              {/* Centered header for icons */}
              <th style={{ textAlign: 'center' }}>Permissions</th>
            </tr>
          </thead>
          <tbody>
            {filteredroles.length > 0 ? (
              filteredroles.map((r) => (
                <tr key={r.role_id}>
                  <td>{r.role_name}</td>
                  <td>{r.description}</td>
                  <td className="action-cell">
                    <div className="action-wrapper">
                      <button 
                        className="icon-action-btn" 
                        onClick={() => handleEditPermission(r)}
                        title="Edit Permissions"
                      >
                        <img src={editIcon} alt="Edit" className="table-icon" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center', padding: '20px' }}>
                  No roles match your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showPermissionForm && selectedRole && (
        <PermissionForm
          role={selectedRole}
          onClose={() => setShowPermissionForm(false)}
          onSave={handleSaveRole}
        />
      )}

      {showAddRoleForm && (
        <AddRoleForm
          onClose={() => setShowAddRoleForm(false)}
          onRoleAdded={handleRoleAdded}
        />
      )}
    </div>
  );
};

export default RoleSearch;